import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { BRAND } from "../config/site";

export default function Footer() {
  return (
    <footer className="bg-[#070C09] border-t border-white/10 pt-20 pb-10 px-6 md:px-16" data-testid="site-footer">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <Logo />
            <p className="serif-italic text-2xl text-sage mt-6 leading-snug">
              “{BRAND.tagline}”
            </p>
          </div>

          <div className="flex gap-16 flex-wrap">
            <div>
              <p className="font-mono text-[0.6rem] uppercase tracking-widest2 text-fern mb-5">Explore</p>
              <ul className="space-y-3 text-sm">
                {[
                  ["/", "Home"],
                  ["/domes", "The Domes"],
                  ["/experiences", "Experiences"],
                  ["/weddings", "Weddings & Events"],
                  ["/about", "Our Story"],
                  ["/contact", "Contact"],
                ].map(([to, label]) => (
                  <li key={to}>
                    <Link
                      to={to}
                      data-testid={`footer-link-${to === "/" ? "home" : to.slice(1)}`}
                      className="text-sage hover:text-lavglow transition-colors"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[0.6rem] uppercase tracking-widest2 text-fern mb-5">Find us</p>
              <p className="text-sm text-sage leading-relaxed max-w-[220px]">{BRAND.address}</p>
              <Link
                to="/book"
                data-testid="footer-booking-link"
                className="group inline-flex items-center gap-1.5 mt-5 font-mono text-[0.68rem] uppercase tracking-[0.18em] text-lavender hover:text-lavglow transition-colors"
              >
                Book online
                <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-16 overflow-hidden">
          <p className="font-display uppercase tracking-[0.12em] text-[8vw] leading-none text-white/[0.06] select-none whitespace-nowrap">
            Danseys Pass
          </p>
        </div>

        <div className="mt-8 flex flex-col md:flex-row justify-between gap-3 border-t border-white/10 pt-6">
          <p className="font-mono text-[0.6rem] uppercase tracking-widest2 text-fern">
            © 2026 {BRAND.name} — All rights reserved
          </p>
          <p className="font-mono text-[0.6rem] uppercase tracking-widest2 text-fern">
            Made in the high country of Aotearoa New Zealand
          </p>
        </div>
      </div>
    </footer>
  );
}
